import React from "react";
import "../../Styles/informations.css";
import Header from "../Header";
import Footer from "../Footer";

function TheseEnCoursScreen() {
  return (
    <>
      <Header />
      <div className="informationScreen my-2">
        <h1 className="color-orange">
          POUR LE MOMENT PAS ENCORE DE THESE REPERTORIES
        </h1>
      </div>
      <Footer />
    </>
  );
}

export default TheseEnCoursScreen;
